import { Component, OnInit } from '@angular/core'
import { RushHeaderComponent } from './rush-header/rush-header.component'
import { RushTabsComponent } from './rush-tabs/rush-tabs.component'
import { RushMainService } from '@rush-shared/services/rush-main.service'
import { CommonModule } from '@angular/common'
import { TabsConst } from '@rush-shared/constants'
import { BetService, RushGameService, RushPopupService } from '@rush-shared/services'
import {
  ChipsAlertComponent,
  PopupComponent,
  PopupDangerComponent,
  PopupSuccessComponent,
  WinnerAlertComponent,
} from '@rush-shared/components'
import { AccountService, WebSocketService } from '@core/services'
import { RushDealResultNotificationModel } from '@rush-core/dtos'
import { RushOtherPageContentComponent } from './rush-other-page-content/rush-other-page-content.component'
import { PlayerService } from '@shared/services'
import { IncommingChipsType } from '@shared/types'
import { IncommingChipsAlertModel } from '@shared/model'
import { BetTypeEnum } from '@shared/enums'

@Component({
  selector: 'app-rush-main',
  standalone: true,
  imports: [
    RushHeaderComponent,
    RushTabsComponent,
    CommonModule,
    RushOtherPageContentComponent,
    PopupComponent,
    PopupSuccessComponent,
    PopupDangerComponent,
    WinnerAlertComponent,
    ChipsAlertComponent,
  ],
  templateUrl: './rush-main.component.html',
  styleUrl: './rush-main.component.sass',
})
export class RushMainComponent implements OnInit {
  gameResult: RushDealResultNotificationModel | undefined

  totalEarning = {
    earned: 0,
    bonus: 0,
  }
  incommingChipsAlert: IncommingChipsAlertModel = {
    activate: false,
    type: 'add',
    chips: 0,
  }

  get showRushWinnerResult() {
    return this.gameResult !== undefined && this.totalEarning.earned > 0
  }

  constructor(
    private _rushGameService: RushGameService,
    private _rushMainService: RushMainService,
    public _betService: BetService,
    private _webSocketService: WebSocketService,
    private _accountService: AccountService,
    private _playerService: PlayerService,
    public _rushPopupService: RushPopupService,
  ) {}

  ngOnInit(): void {
    this._rushGameService.loadInitData()
    this._rushGameService.loadGameConfig()

    this.startGameResultListener()
  }

  isTabSelected() {
    return TabsConst.some((i) => i.name === this._rushMainService.activeTab$.value.name)
  }

  onBetConfirmationHide() {
    this._betService.setCurrentBet(
      this._betService.currentBet$.value.type,
      this._betService.currentBet$.value.chips,
      false,
    )
  }

  onBetResultHide() {
    this._rushPopupService.hideSuccessPopup()
  }

  changeActiveTab() {
    const rushTab = TabsConst[0],
      classicTab = TabsConst[1],
      activeTab = this._rushMainService.activeTab$.value

    const newActiveTab = activeTab.name === rushTab.name ? classicTab : rushTab

    this._rushMainService.setActiveTab(newActiveTab)
  }

  private startGameResultListener() {
    this._webSocketService.listenToRushBetTotalUpdate((betTotal) => {
      this._rushGameService.setBetTotal(betTotal)
    })

    this._webSocketService.listenToRushGameResult(this._accountService.currentUserId, (result) => {
      setTimeout(() => this.setGameResult(result), 2500)
    })

    this._webSocketService.listenToIncommingChips(
      this._accountService.currentUserId,
      (incomming) => {
        this._accountService.updateChips(incomming.currentChips)

        if (this._playerService.activePlayer) {
          this._playerService.activePlayer.chips = incomming.currentChips
        }

        this._playerService.incommingChips = { ...incomming, show: true }
        this.showChipsAlert(incomming.useEarnClass ? 'add' : 'deduct', incomming.chips)
      },
    )
  }

  hideChipsAlert() {
    this.incommingChipsAlert = {
      activate: false,
      type: 'add',
      chips: 0,
    }
  }

  showChipsAlert(type: IncommingChipsType, chips: number) {
    this.incommingChipsAlert = {
      activate: true,
      type,
      chips,
    }
  }

  hideRushWinnerResult() {
    this.gameResult = undefined
    this.totalEarning.earned = 0
  }

  private setGameResult(result: RushDealResultNotificationModel) {
    this.gameResult = result

    if (result?.betSummaries.some((i) => i.isWinner === true || (i.isWinner as any) == 1)) {
      const winnerResults = this.gameResult?.betSummaries.filter((i) => i.isWinner)

      this.totalEarning = {
        earned: winnerResults?.reduce((prev, next) => prev + next.earnedChips, 0),
        bonus: winnerResults?.reduce((prev, next) => prev + next.totalBonus, 0),
      }

      this.showChipsAlert('add', this.totalEarning.earned)

      this._betService.currentBet$.setValue({
        type: BetTypeEnum.FOLD,
        chips: 0,
        show: false,
      })
    }

    this._accountService.updateChips(result.chips)
    this._rushGameService.setWinStreak(result.winStreakCount)
    this._rushGameService.clearPlayerBets()
    this._rushGameService.clearTotalBets()
  }
}
